import React, { Fragment, useState, useEffect } from "react";
import { propOr, slice } from "ramda";
import axios from "axios";
import Loading from "./Desktop/Loading";
import LeaderboardDesktop from "./Desktop/LeaderboardDesktop";
import LeaderboardMobile from "./Mobile/LeaderboardMobile";
import {
  fetchHeader,
  fetchTrophyHeaders,
  fetchTrophyWinners,
  isEmptyOrNil,
} from "./utils";
import { fetchLocale } from "shared/helpers/localeHelper";

import { IntlProvider } from "react-intl";
import "./Leaderboard.scss";

const CHECK_FOR_UPDATES_TIMER = 1000 * 30; // 30 seconds
let currentTimer;

const Leaderboard = ({ currencyCode, language, sectionData }) => {
  const [data, setData] = useState({});
  const [firstPlace, setFirstPlace] = useState(null);
  const [secondPlace, setSecondPlace] = useState(null);
  const [thirdPlace, setThirdPlace] = useState(null);
  const [tableRows, setTableRows] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [trophyHeaders, setTrophyHeaders] = useState([]);
  const FETCH_SECTIONS_API = `/microsite/api/sections/${sectionData.id}`;

  async function fetchSectionData() {
    const { data } = await axios(FETCH_SECTIONS_API);
    const rows = propOr([], "rows", data);

    setData(data);
    setHeaders(fetchHeader(data));
    setFirstPlace(fetchTrophyWinners(slice(0, 1))(rows));
    setSecondPlace(fetchTrophyWinners(slice(1, 2))(rows));
    setThirdPlace(fetchTrophyWinners(slice(2, 3))(rows));
    setTableRows(slice(3, Infinity, rows));
    setHeaders(fetchHeader(data));
    setTrophyHeaders(fetchTrophyHeaders(data));

    clearTimeout(currentTimer);
    currentTimer = setTimeout(() => fetchSectionData(), CHECK_FOR_UPDATES_TIMER);
  }

  useEffect(() => {
    fetchSectionData();
  }, []);

  if (isEmptyOrNil(data)) {
    return (
      <div className="leaderboard-loading">
        <Loading />
      </div>
    );
  }

  return (
    <Fragment>
      <IntlProvider locale={fetchLocale(language)}>
        <LeaderboardMobile
          currencyCode={currencyCode}
          data={data}
          firstPlace={firstPlace}
          headers={headers}
          secondPlace={secondPlace}
          tableRows={tableRows}
          thirdPlace={thirdPlace}
          trophyHeaders={trophyHeaders}
        />
        <LeaderboardDesktop
          currencyCode={currencyCode}
          data={data}
          firstPlace={firstPlace}
          headers={headers}
          secondPlace={secondPlace}
          tableRows={tableRows}
          thirdPlace={thirdPlace}
          trophyHeaders={trophyHeaders}
        />
      </IntlProvider>
    </Fragment>
  );
};

export default (props) => <Leaderboard {...props} />;
